<script setup>
import { ModalsContainer } from 'vue-final-modal';

import localStorageKeys from '@/constants/local-storage-keys';

const props = defineProps({
  error: {
    type: Object,
    default: () => ({}),
  },
});
if (process.server) {
  const error = props.error;
  console.error({
    'errorData===': error.message,
    statusCode: error.statusCode,
    statusMessage: error.statusMessage,
    url: error.url,
    stack: error.stack,
  });
}
const { t } = useI18n();

// Cookies
const route = useRoute();
const authStore = useAuthStore();

const showCookiesBanner = ref(false);
const isCookiesAccepted = useLocalStorage(
  localStorageKeys.COOKIES_ACCEPTED,
  false,
);

watch(
  () => route.path,
  () => {
    setTimeout(() => {
      showCookiesBanner.value = true;
    }, 5000);
  },
  { immediate: true },
);

// GA
async function initMetrics() {
  const {
    public: { gtmID },
  } = useRuntimeConfig();

  const metrics = useMetrics({ gtmID });
  metrics.init();

  if (isCookiesAccepted.value) {
    try {
      await gtagPushConsent('consent', 'update', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'granted',
      });

      await authStore.updateSessionInformation();
    } catch (error) {
      console.log(error);
    }
  }
}

onMounted(initMetrics);
</script>

<template>
  <div id="app" class="error">
    <NuxtLayout
      class="error__layout"
      name="default"
      hide-footer-contacts
      hide-banner
    >
      <SectionErrorIntro
        class="error__intro"
        :title="t(`error.${error.statusCode}`)"
      />
      <ModalsContainer />
    </NuxtLayout>

    <ClientOnly>
      <Transition name="fade">
        <BundlesCookies
          v-if="!isCookiesAccepted && showCookiesBanner"
          class="error__cookies"
        />
      </Transition>
    </ClientOnly>
  </div>
</template>

<style scoped lang="scss">
.error {
  $parent: &;

  display: flex;
  flex-direction: column;
  background-color: $color-gray-5;

  &:deep(#{$parent}__layout) {
    flex-grow: 1;
  }

  &__cookies {
    position: fixed;
    bottom: em($gap-sm);
    left: 50%;
    z-index: 10;

    @include media-breakpoint-up(sm) {
      max-width: em(360);
      transform: translateX(-50%);
    }

    @include media-breakpoint-down(sm) {
      right: em($gap-sm);
      left: em($gap-sm);
    }
  }
}
</style>
